import React from 'react';
import Alert from 'react-s-alert';

function generateBox(icon,message) {
	return (
		<div>
			<i style={{fontWeight:'bold'}} className={icon}></i> 
			<span style={{paddingLeft:'20px'}}>{message}</span>
		</div>
	);
}

export default class Notification {

	static clear() {
		Alert.closeAll();
	}

	static success(message) {
		Alert.closeAll();
		return Alert.success(generateBox('icon wb-check',message), {
            position: 'top-right',
            effect: 'slide',
            timeout: 5000
        });
	}

	static error(message) {
		Alert.closeAll();
		Alert.error(generateBox('icon wb-alert',message), {
            position: 'top-right',
            effect: 'slide',
            timeout: 5000
        });
	}

	static warning(message) {
		Alert.closeAll();
		Alert.warning(generateBox('icon wb-alert',message), {
            position: 'top-right',
            effect: 'slide',
            timeout: 5000
        });
	}

	static info(message) {
		Alert.closeAll();
		Alert.info(generateBox('icon wb-bell',message), {
            position: 'top-right',
            effect: 'slide',
            timeout: 5000
        });
	}
}





// WEBPACK FOOTER //
// ./components/Notification.js